const hashtagConfig = {
  separator: " ",
  trigger: "#",
};

export default hashtagConfig;